import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildServiceSchema } from '../../builders/service'
import { PageMeta } from '../../types'

const description = "プロトタイピングで高速に仮説を検証し、ユーザー体験を最適化します。アイデアを形にし、素早くフィードバックを得ることで最適な製品開発を実現します。"

export const prototypingPageMeta: PageMeta = {
  title: "プロトタイピング・仮説検証 | サービス | i3DESIGN アイスリーデザイン",
  description,
  keyword: "プロトタイピング 仮説検証 Figma テクニカル ユーザー検証 AI活用",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/prototyping/`,
}

export const prototypingSchema = buildServiceSchema({
  slug: "prototyping",
  name: "プロトタイピング・仮説検証",
  description: prototypingPageMeta.description,
  serviceType: "プロトタイピング・仮説検証",
  category: "デジタルプロダクトデザイン",
  offerCatalogName: "プロトタイピング・仮説検証サービス",
  breadcrumbName: "プロトタイピング・仮説検証",
  offers: [
    {
      name: "コンセプトプロトタイプ",
      description: "コンセプトプロトタイプは、アイデアの初期段階においてビジネスコンセプトの実現可能性や市場価値を検証するための試作モデルです。ランディングページやストーリーボードなどでビジョンを可視化してステークホルダーやユーザーと共有し、早期にフィードバックを得ることで、チーム全体で共通の理解を形成することを目的としています。",
    },
    {
      name: "デザインプロトタイプ",
      description: "デザインプロトタイプは、主にFigma等を用いてインターフェースやユーザーフローを視覚化し、アプリケーションの見た目や操作体験を具体化するものです。クリック可能なモデルを通じて、本格的な開発に着手する前にユーザビリティテストやデザインの評価・改善を行い、プロダクトの品質を高めることを目的としています。",
    },
    {
      name: "テクニカルプロトタイプ",
      description: "テクニカルプロトタイプは、主要な機能やアルゴリズムを試験的に実装することで、技術的な実現可能性やシステムのリスクを検証するためのモデルです。開発チームが採用するフレームワークの評価や性能テストを行い、本格的な開発における技術的な課題を早期に特定・解決することを目的としています。",
    }
  ],
})
